// extracted by mini-css-extract-plugin
module.exports = {"loading-error-container":"style_loading-error-container__7xiT6","loading-error-button":"style_loading-error-button__2DOrZ"};